module.exports = __webpack_public_path__ + "img/afrikan-heroes.65428048.png";